module.exports = __webpack_public_path__ + "pump_cases.jpg?4d90a2a4927a3730be53bde4b6e16087";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cases/pump_cases.jpg
// module id = 92
// module chunks = 0